// Code generated by protoc-gen-ts. DO NOT EDIT.
// protoc-gen-ts is an Art Processors production, found in mos-sdk-py.

import { Placement } from "generated/mos/placement";
import { POI, POIType } from "generated/mos/poi";
import { Codec, DecodeContext, FieldMask, RemoteObject, WebRPCError, decodeMessageRepeated, ensureScalar, stripTypePropertyDeep } from "generated/webrpc";

export namespace CreatePOIRequest {
  export const refName = "mos.poi_management.CreatePOIRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly name: string,
    readonly poiTypeRef: { readonly typename: 'mos.poi.POIType', readonly id: string } | undefined,
    readonly visitorInfo: string,
    readonly locations: ReadonlyArray<Placement.Entity>,
    // If the media's kind is neither MEDIA_KIND_RASTER_IMAGE nor MEDIA_KIND_VECTOR_IMAGE,
    // an error is raised:
    readonly imageMediaRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    name: "",
    poiTypeRef: undefined,
    visitorInfo: "",
    locations: [],
    imageMediaRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["name"] = v.name;
      obj["poiTypeRef"] = v.poiTypeRef;
      obj["visitorInfo"] = v.visitorInfo;
      obj["locations"] = [];
      for (const item of v.locations) {
        obj["locations"].push(Placement.codec.encode(item));
      }
      obj["imageMediaRef"] = v.imageMediaRef;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.poi_management.CreatePOIRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["name"] = ensureScalar(ctx, v["name"], "string");
      out["poiTypeRef"] = v["poiTypeRef"];
      out["visitorInfo"] = ensureScalar(ctx, v["visitorInfo"], "string");
      out["locations"] = decodeMessageRepeated(ctx, Placement.codec, v["locations"], "locations");
      out["imageMediaRef"] = v["imageMediaRef"];
      return out as any as Entity;
    }
  }();
}

export namespace CreatePOIResponse {
  export const refName = "mos.poi_management.CreatePOIResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly poi: POI.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    poi: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["poi"] = POI.codec.encode(v.poi);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.poi_management.CreatePOIResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["poi"] = ctx.decode(POI.codec, v["poi"], "poi");
      return out as any as Entity;
    }
  }();
}

export namespace CreatePOITypeRequest {
  export const refName = "mos.poi_management.CreatePOITypeRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly name: string,
    readonly iconMediaRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    name: "",
    iconMediaRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.poi_management.CreatePOITypeRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["name"] = ensureScalar(ctx, v["name"], "string");
      out["iconMediaRef"] = v["iconMediaRef"];
      return out as any as Entity;
    }
  }();
}

export namespace CreatePOITypeResponse {
  export const refName = "mos.poi_management.CreatePOITypeResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly poiType: POIType.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    poiType: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.poi_management.CreatePOITypeResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["poiType"] = ctx.decode(POIType.codec, v["poiType"], "poiType");
      return out as any as Entity;
    }
  }();
}

export namespace DeletePOIRequest {
  export const refName = "mos.poi_management.DeletePOIRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly poiRef: { readonly typename: 'mos.poi.POI', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    poiRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.poi_management.DeletePOIRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["poiRef"] = v["poiRef"];
      return out as any as Entity;
    }
  }();
}

export namespace DeletePOIResponse {
  export const refName = "mos.poi_management.DeletePOIResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.poi.POI', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.poi_management.DeletePOIResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      return out as any as Entity;
    }
  }();
}

export namespace DeletePOITypeRequest {
  export const refName = "mos.poi_management.DeletePOITypeRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly poiTypeRef: { readonly typename: 'mos.poi.POIType', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    poiTypeRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.poi_management.DeletePOITypeRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["poiTypeRef"] = v["poiTypeRef"];
      return out as any as Entity;
    }
  }();
}

export namespace DeletePOITypeResponse {
  export const refName = "mos.poi_management.DeletePOITypeResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly poiTypeRef: { readonly typename: 'mos.poi.POIType', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    poiTypeRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.poi_management.DeletePOITypeResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["poiTypeRef"] = v["poiTypeRef"];
      return out as any as Entity;
    }
  }();
}

export namespace UpdatePOIRequest {
  export const refName = "mos.poi_management.UpdatePOIRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly poiRef: { readonly typename: 'mos.poi.POI', readonly id: string } | undefined,
    readonly updateMask: FieldMask<"poiRef" | "name" | "poiTypeRef" | "visitorInfo" | "locations" | "imageMediaRef">,
    readonly name: string,
    readonly poiTypeRef: { readonly typename: 'mos.poi.POIType', readonly id: string } | undefined,
    readonly visitorInfo: string,
    readonly locations: ReadonlyArray<Placement.Entity>,
    // If the media's kind is neither MEDIA_KIND_RASTER_IMAGE nor MEDIA_KIND_VECTOR_IMAGE,
    // an error is raised:
    readonly imageMediaRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    poiRef: undefined,
    updateMask: { type: "google.protobuf.FieldMask", fields: [] },
    name: "",
    poiTypeRef: undefined,
    visitorInfo: "",
    locations: [],
    imageMediaRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["poiRef"] = v.poiRef;
      obj["updateMask"] = v.updateMask.fields.join(",");
      obj["name"] = v.name;
      obj["poiTypeRef"] = v.poiTypeRef;
      obj["visitorInfo"] = v.visitorInfo;
      obj["locations"] = [];
      for (const item of v.locations) {
        obj["locations"].push(Placement.codec.encode(item));
      }
      obj["imageMediaRef"] = v.imageMediaRef;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.poi_management.UpdatePOIRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["poiRef"] = v["poiRef"];
      {
        const fmvs = ensureScalar(ctx, v["updateMask"], "string").split(/\s,\s/);
        for (const fmv of fmvs) {
          if (fmv !== "poiRef" && fmv !== "name" && fmv !== "poiTypeRef" && fmv !== "visitorInfo" && fmv !== "locations" && fmv !== "imageMediaRef") {
            throw ctx.error(`received invalid value ${fmv} in field mask`);
          }
        }
        out["updateMask"] = fmvs;
      }
      out["name"] = ensureScalar(ctx, v["name"], "string");
      out["poiTypeRef"] = v["poiTypeRef"];
      out["visitorInfo"] = ensureScalar(ctx, v["visitorInfo"], "string");
      out["locations"] = decodeMessageRepeated(ctx, Placement.codec, v["locations"], "locations");
      out["imageMediaRef"] = v["imageMediaRef"];
      return out as any as Entity;
    }
  }();
}

export namespace UpdatePOIResponse {
  export const refName = "mos.poi_management.UpdatePOIResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly poi: POI.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    poi: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["poi"] = POI.codec.encode(v.poi);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.poi_management.UpdatePOIResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["poi"] = ctx.decode(POI.codec, v["poi"], "poi");
      return out as any as Entity;
    }
  }();
}

export namespace UpdatePOITypeRequest {
  export const refName = "mos.poi_management.UpdatePOITypeRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly poiTypeRef: { readonly typename: 'mos.poi.POIType', readonly id: string } | undefined,
    readonly updateMask: FieldMask<"poiTypeRef" | "name" | "iconMediaRef">,
    readonly name: string,
    readonly iconMediaRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    poiTypeRef: undefined,
    updateMask: { type: "google.protobuf.FieldMask", fields: [] },
    name: "",
    iconMediaRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["poiTypeRef"] = v.poiTypeRef;
      obj["updateMask"] = v.updateMask.fields.join(",");
      obj["name"] = v.name;
      obj["iconMediaRef"] = v.iconMediaRef;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.poi_management.UpdatePOITypeRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["poiTypeRef"] = v["poiTypeRef"];
      {
        const fmvs = ensureScalar(ctx, v["updateMask"], "string").split(/\s,\s/);
        for (const fmv of fmvs) {
          if (fmv !== "poiTypeRef" && fmv !== "name" && fmv !== "iconMediaRef") {
            throw ctx.error(`received invalid value ${fmv} in field mask`);
          }
        }
        out["updateMask"] = fmvs;
      }
      out["name"] = ensureScalar(ctx, v["name"], "string");
      out["iconMediaRef"] = v["iconMediaRef"];
      return out as any as Entity;
    }
  }();
}

export namespace UpdatePOITypeResponse {
  export const refName = "mos.poi_management.UpdatePOITypeResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly poiType: POIType.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    poiType: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.poi_management.UpdatePOITypeResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["poiType"] = ctx.decode(POIType.codec, v["poiType"], "poiType");
      return out as any as Entity;
    }
  }();
}

